(function ($, Drupal) {
  // Make submenu full browser width.
  const submenuFullwidthCalc = function () {
    const offsetTarget = $('.tb-megamenu').offset();
    const offset = 0 - offsetTarget.left;
    $('.tb-megamenu .level-1 > .tb-megamenu-submenu').each(function () {
      $(this).css('left', offset);
    });
  };

  Drupal.behaviors.megaMenuFullWidth = {
    attach() {
      $(document).ready(function() {
        submenuFullwidthCalc();

        $(window).on('resize', function () {
          submenuFullwidthCalc();
        });
      });
    }
  };
}(jQuery, Drupal));
